import SuiBox from "components/SuiBox";
import SuiTypography from "components/SuiTypography";
import { useSortable } from "@dnd-kit/sortable";
import FirstPageViewer from "components/PdfViewer";
import { Icon } from "@mui/material";
import { useHistory } from "react-router-dom";
import PropTypes from "prop-types";

export const SortableMaterials = ({
  id,
  material,
  setSelectedMaterials,
  setMergedPdfUrl,
  setFinalState,
  selectedLettersString,
  materialTypesString,
  finalState,
  selectedMaterials,
  isReorderMode,
  index,
}) => {
  const history = useHistory();

  const checkItemsCount = (materialParam) => {
    if (materialParam.length === 0) {
      history.push("/sound-materials/create");
    }
  };

  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({
    id,
  });

  const style = {
    transform: transform ? `translate3d(${transform.x}px, ${transform.y}px, 0)` : undefined,
    transition,
    opacity: isDragging ? 0.5 : 1,
  };

  return (
    <div>
      <div
        key={`material-${material.selectionOrder}-${material.fileUrl.substring(0, 10)}`}
        index={index}
      >
        <SuiBox
          ref={setNodeRef}
          style={style}
          sx={{
            width: "198px",
            height: "280px",
            backgroundColor: "white",
            borderRadius: "lg",
            boxShadow: isDragging ? "lg" : "sm",
            border: "1px solid",
            borderColor: "grey.300",
            flexShrink: 0,
            position: "relative",
            display: "flex",
            flexDirection: "column",
            padding: 2,
            alignItems: "center",
            justifyContent: "center",
            cursor: isReorderMode ? "grab" : "default",
          }}
        >
          {isReorderMode && (
            <SuiBox
              {...attributes}
              {...listeners}
              sx={{
                position: "absolute",
                top: "0px",
                left: "0px",
                width: "198px",
                height: "280px",
                cursor: "grab",
                zIndex: 2,
              }}
            />
          )}
          <SuiBox
            sx={{
              position: "absolute",
              top: "10px",
              left: "10px",
              width: "30px",
              height: "30px",
              borderRadius: "50%",
              backgroundColor: "rgb(52, 71, 103)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              zIndex: 3,
            }}
          >
            <SuiTypography
              variant="button"
              sx={{
                color: "rgb(255, 255, 255)",
                fontWeight: 600,
              }}
            >
              {material.selectionOrder}
            </SuiTypography>
          </SuiBox>
          {isReorderMode && (
            <SuiBox
              onClick={(e) => {
                e.stopPropagation();
                const updatedMaterials = selectedMaterials
                  .filter((m) => m.selectionOrder !== material.selectionOrder)
                  .map((m, idx) => ({
                    ...m,
                    selectionOrder: idx + 1,
                  }));
                checkItemsCount(updatedMaterials);
                setSelectedMaterials(updatedMaterials);
                setMergedPdfUrl(null);
                if (finalState) {
                  setFinalState({
                    ...finalState,
                    selectedMaterials: updatedMaterials,
                    selectedLettersString,
                    materialTypesString,
                  });
                }
              }}
              sx={{
                position: "absolute",
                top: "10px",
                right: "10px",
                width: "30px",
                height: "30px",
                borderRadius: "50%",
                backgroundColor: "rgb(220, 53, 69)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                zIndex: 3,
                cursor: "pointer",
                "&:hover": {
                  backgroundColor: "rgb(200, 35, 51)",
                },
              }}
            >
              <Icon sx={{ color: "rgb(255, 255, 255)", fontSize: "1rem" }}>close</Icon>
            </SuiBox>
          )}
          <FirstPageViewer fileUrl={material.fileUrl} />
          <SuiTypography variant="caption" mt={1}>
            {material.name}
          </SuiTypography>
          {isReorderMode && (
            <SuiBox
              onClick={(e) => {
                e.stopPropagation();
                const currentIndex = selectedMaterials.findIndex(
                  (m) => m.selectionOrder === material.selectionOrder
                );
                const newMaterial = {
                  name: "Boş Sayfa",
                  fileUrl:
                    "https://edictdigitalspaces.fra1.digitaloceanspaces.com/karina/dddde9bf-d02d-40c4-bbb7-0b1f8244f396.pdf",
                  selectionOrder: selectedMaterials.length + 1,
                };
                const updatedMaterials = [
                  ...selectedMaterials.slice(0, currentIndex + 1),
                  newMaterial,
                  ...selectedMaterials.slice(currentIndex + 1),
                ].map((m, idx) => ({
                  ...m,
                  selectionOrder: idx + 1,
                }));
                setSelectedMaterials(updatedMaterials);
                setMergedPdfUrl(null);
                if (finalState) {
                  setFinalState({
                    ...finalState,
                    selectedMaterials: updatedMaterials,
                    selectedLettersString,
                    materialTypesString,
                  });
                }
              }}
              sx={{
                position: "absolute",
                bottom: "10px",
                right: "10px",
                width: "30px",
                height: "30px",
                borderRadius: "50%",
                backgroundColor: "rgb(52, 71, 103)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                zIndex: 3,
                cursor: "pointer",
                "&:hover": {
                  backgroundColor: "rgb(42, 61, 93)",
                },
              }}
            >
              <Icon sx={{ color: "rgb(255, 255, 255)", fontSize: "1rem" }}>add</Icon>
            </SuiBox>
          )}
        </SuiBox>
      </div>
    </div>
  );
};

SortableMaterials.propTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  material: PropTypes.shape({
    selectionOrder: PropTypes.number,
    fileUrl: PropTypes.string,
    name: PropTypes.string,
  }).isRequired,
  setSelectedMaterials: PropTypes.func.isRequired,
  setMergedPdfUrl: PropTypes.func.isRequired,
  setFinalState: PropTypes.func.isRequired,
  selectedLettersString: PropTypes.string.isRequired,
  materialTypesString: PropTypes.string.isRequired,
  finalState: PropTypes.shape({}).isRequired,
  selectedMaterials: PropTypes.arrayOf(
    PropTypes.shape({
      selectionOrder: PropTypes.number,
      fileUrl: PropTypes.string,
      name: PropTypes.string,
    })
  ).isRequired,
  isReorderMode: PropTypes.bool.isRequired,
  index: PropTypes.number.isRequired,
};
